import React from 'react';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import NodePartnerTeaser from './Teaser';
import NodePartnerTeaserSmall from './TeaserSmall';

import { NodePartner } from '../../../types/uncinc_profile/nodes';

interface NodePartnerProps {
  entity: ImmutableEntity<NodePartner>;
  viewMode: string;
}

const NodePartnerWrapper: React.FC<NodePartnerProps> = ({ entity, viewMode }) => {
  switch (viewMode) {
    case 'teaser_small':
      return <NodePartnerTeaserSmall entity={entity} />;
    default:
      return <NodePartnerTeaser entity={entity} />;
  }
};

export default NodePartnerWrapper;
